<script>
import { getNotificationInQueue, NOTIFICATIONS_UPDATED_EVENT } from '../Modules/WebSockets.js';
import { notificationLabel } from '../Constants/NotificationLabels.js';
import LetterIcon from '../Components/LetterIcon.vue';
import { humanTimeFromNow } from '../Modules/Dates.js';
import { genericError } from '../Modules/Alerts.js';
import { setupUserPermissionsForNotification } from '../Modules/Notifications.js';
import { confirm } from '../Modules/Confirmation.js';
import { decode } from 'html-entities';
import moment from 'moment-timezone';

export default {
  components: { LetterIcon },

  data() {
    return {
      masterConfig: this.$page.props.master_config,
      user: this.$page.props.auth.user,
      toggles: this.$page.props.toggles || {},
      wss_url: this.$page.props.wss_url,
      notifications: [...(window.notifications ?? [])],
      syncNotifications: null,
      slow: false,
    };
  },

  computed: {
    notificationCounter() {
      return this.orderedNotifications.length;
    },

    orderedNotifications() {
      if (this.notifications.length === 0) {
        return [];
      }

      let notification_keys = [];

      let notifications = this.notifications
        .filter((notification) => {
          const key = `${notification.id}|${notification.notify}`;
          if (!notification_keys.includes(key)) {
            notification_keys.push(key);
            return true;
          }
          return false;
        })
        .sort(function (a, b) {
          let a_timestamp = moment(a.date_time).unix();
          let b_timestamp = moment(b.date_time).unix();
          return b_timestamp - a_timestamp;
        });

      return notifications;
    },
  },

  mounted() {
    if (this.masterConfig && this.user && this.wss_url) {
      setupUserPermissionsForNotification();
      // Ensure toggles has a default value for notifications_retention
      const togglesWithDefault = {
        ...this.toggles,
        notifications_retention: this.toggles?.notifications_retention ?? 7,
      };
      this.syncNotifications = (event) => {
        this.notifications = [...(event.detail ?? window.notifications ?? [])];
      };
      window.addEventListener(NOTIFICATIONS_UPDATED_EVENT, this.syncNotifications);
      getNotificationInQueue(this.wss_url, this.masterConfig, this.user, togglesWithDefault);
    }
  },

  beforeUnmount() {
    if (this.syncNotifications) {
      window.removeEventListener(NOTIFICATIONS_UPDATED_EVENT, this.syncNotifications);
    }
  },

  methods: {
    humanTimeFromNow,

    notificationLabel,

    pollNotifications() {
      this.notifications = [...(window.notifications ?? [])];
      setTimeout(() => {
        this.notifications = [...(window.notifications ?? [])];
        this.pollNotifications();
      }, 3000);
    },

    decode(message) {
      return decode(message);
    },

    readNotification(notification) {
      axios
        .post(
          route('notifications.read', { shop_id: this.masterConfig.shop_id, id: notification.id }),
          {
            notify: notification.notify,
          },
        )
        .then((response) => {
          window.location.href = notification.href;
        })
        .catch((error) => {
          genericError();
        });
    },

    clearAll() {
      confirm('Are you sure you want to clear all notifications?').then((response) => {
        axios
          .post(
            route('notifications.clear-all', {
              shop_id: this.masterConfig.shop_id,
            }),
          )
          .then((response) => {
            notyf.success('Notifications have been cleared');
            window.notifications = [];
            this.notifications = [];
          });
      });
    },
  },
};
</script>

<template>
  <a
    id="alertsDropdown"
    class="nav-icon dropdown-toggle show"
    href="#"
    data-bs-toggle="dropdown"
    aria-expanded="true"
  >
    <div class="position-relative">
      <i class="fa fa-bell" />
      <span v-if="notificationCounter > 0" class="indicator">{{ notificationCounter }}</span>
    </div>
  </a>

  <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end py-0" data-bs-popper="static">
    <div class="dropdown-menu-header">{{ notificationCounter }} New Notifications</div>
    <div id="notifications-dropdown" class="list-group">
      <a
        v-for="notification in orderedNotifications"
        class="list-group-item"
        @click="readNotification(notification)"
      >
        <div class="row g-0 align-items-center">
          <div class="col-2">
            <LetterIcon size="3x" :letter="notificationLabel(notification.notify)" />
          </div>

          <div class="col-10">
            <div class="text-dark">{{ decode(notification.name) }}</div>
            <div class="text-muted small mt-1">
              {{ humanTimeFromNow(notification.date_time, masterConfig.time_zone) }}
            </div>
            <div class="text-muted small mt-1">{{ decode(notification.message) }}</div>
            <div
              v-if="notification.invoice !== undefined && notification.invoice.length > 0"
              class="text-muted small mt-1"
            >
              RO# {{ notification.invoice }}
            </div>
          </div>
        </div>
      </a>
    </div>

    <div class="dropdown-menu-footer">
      <span v-if="notificationCounter > 0" href="#" class="text-muted" @click="clearAll"
        >Clear All</span
      >
    </div>
  </div>
</template>

<style scoped>
.nav-icon {
  font-size: 1.2rem;
}

.nav-icon .indicator {
  right: -10px;
  top: -8px;
  background: #dc3545;
}

#notifications-dropdown {
  height: 400px;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
